import type { NativeFiles } from "./native-files";
import type { NativeSession } from "../native/session";
/** Publication points to the exact saved version, never a later concurrent draft. */
export class NativePublication {
  private busy = false;
  constructor(
    files: NativeFiles,
    session: NativeSession,
    prepare: () => boolean,
    message: (s: string, error?: boolean) => void,
  ) {
    if (session.mode !== "interactive") return;
    const menu = document.querySelector(".save-menu-panel")!;
    const button = document.createElement("button");
    button.id = "native-publish";
    button.textContent = "Опубликовать";
    button.onclick = async () => {
      if (this.busy || !prepare()) return;
      this.busy = true;
      button.disabled = true;
      try {
        const saved = await files.saveCloud();
        if (!saved || saved.generation !== session.generation) return;
        if (!saved.version)
          throw new Error(
            "Сервер не вернул номер сохранённой версии. Повторите публикацию.",
          );
        const result = await files.api("/projects", {
          action: "publish",
          projectId: saved.project,
          versionId: saved.version,
        });
        if (saved.generation !== session.generation) return;
        const publication = result.publication!;
        const url = new URL(
          `/creator/player/${encodeURIComponent(publication.teacher_slug)}/${encodeURIComponent(publication.project_slug)}`,
          location.origin,
        );
        const dialog = document.createElement("dialog");
        dialog.className = "native-file-dialog";
        const title = document.createElement("h2");
        title.textContent = "Проект опубликован";
        const link = document.createElement("a");
        link.href = url.href;
        link.target = "_blank";
        link.rel = "noopener";
        link.textContent = "Открыть опубликованный проект";
        const input = document.createElement("input");
        input.value = url.href;
        input.readOnly = true;
        input.ariaLabel = "Ссылка на проект";
        input.onclick = () => input.select();
        const copy = document.createElement("button");
        copy.textContent = "Копировать ссылку";
        copy.onclick = () =>
          void navigator.clipboard.writeText(url.href).then(
            () => message("Ссылка скопирована."),
            () => {
              input.focus();
              input.select();
              message("Выделенная ссылка доступна для копирования.");
            },
          );
        const results = document.createElement("a");
        results.href = "/creator/projects";
        results.target = "_blank";
        results.rel = "noopener";
        results.textContent = "Результаты в кабинете";
        const close = document.createElement("button");
        close.textContent = "Закрыть";
        close.onclick = () => dialog.close();
        dialog.append(title, link, input, copy, results, close);
        document.getElementById("native-editor")!.append(dialog);
        dialog.onclose = () => dialog.remove();
        dialog.showModal();
        message(
          "Сохранённая версия опубликована. Новые правки публикуются повторно.",
        );
      } catch (e) {
        message((e as Error).message, true);
      } finally {
        this.busy = false;
        button.disabled = false;
      }
    };
    menu.append(button);
  }
}
